// Centralised class-level definitions for MyClassAI.
//
// Academic classes (6-10): full feature set — topic tests, AI tutor, audio learning,
// skill assessment, exams. Class 10 SCERT (AP 2024-25) added Feb 2026.
// Admin-only classes (LKG, UKG, 1-5): HT manages student records, attendance,
// fees ONLY. No student dashboard, no AI features, no login account is created
// when a student is added.

export const ACADEMIC_CLASS_LEVELS = ['6', '7', '8', '9', '10'];

export const ADMIN_ONLY_CLASS_LEVELS = ['LKG', 'UKG', '1', '2', '3', '4', '5'];

// Ordered list used for dropdowns / filters.
export const ALL_CLASS_LEVELS = [
  'LKG', 'UKG', '1', '2', '3', '4', '5',
  '6', '7', '8', '9', '10',
];

export const isAcademicClass = (cl) => ACADEMIC_CLASS_LEVELS.includes(String(cl));

// Display label: "LKG" stays "LKG", "1" becomes "Class 1"
export const formatClassLabel = (cl) => {
  const s = String(cl ?? '').trim();
  if (!s) return '';
  if (s === 'LKG' || s === 'UKG') return s;
  return `Class ${s}`;
};

// Short label for tight UIs (e.g. badges, table cells)
export const formatClassShort = (cl) => {
  const s = String(cl ?? '').trim();
  if (s === 'LKG' || s === 'UKG') return s;
  return s;
};
